import React from "react";
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  ChartLabel,
  LineSeries,
} from "react-vis";
import "react-vis/dist/style.css";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";

import { storeColors } from "../../../store/reducers/reports";

const months = ["12/19", "01/20", "02/20", "03/20", "04/20", "05/20", "06/20"];

const RecentTrends = (props) => {
  const { stores, selectedAttributes, recentTrendsStats } = props;
  const [min, max] = recentTrendsStats[selectedAttributes[0]];
  const domain = [min, max];
  return (
    <AutoSizer>
      {({ width, height }) => (
        <XYPlot
          width={width}
          height={height}
          margin={{ top: 30, left: 50, right: 20 }}
          xDomain={[0, 6]}
          yDomain={domain}
          strokeType="literal"
        >
          <VerticalGridLines />
          <HorizontalGridLines />
          <XAxis
            title="Months"
            style={{
              text: {
                stroke: "none",
                fill: "black",
                fontSize: 14,
                fontWeight: 400,
              },
            }}
            tickValues={[0, 1, 2, 3, 4, 5, 6]}
            tickFormat={(t) => months[t]}
          />
          <ChartLabel
            text={selectedAttributes[0]}
            includeMargin={true}
            xPercent={0.07}
            yPercent={-0.045}
          />
          <YAxis />
          {stores.map((s, index) => (
            <LineSeries
              key={index}
              className="first-series"
              curve={"curveMonotoneX"}
              strokeDasharray="7, 3"
              data={s[selectedAttributes[0]].map((g, index) => ({
                x: index,
                y: g,
              }))}
              color={storeColors[index]}
            />
          ))}
        </XYPlot>
      )}
    </AutoSizer>
  );
};

export default React.memo(RecentTrends);
